import { buildModule } from '../utils';
import detail from './detail';
import groups from './groups';

export default buildModule()
	.withSubmodules({
		detail,
		groups,
	});


